import type { RegistrationConfig } from '../types';
import { COMMON_REG_CONFIG } from './basic';

export const GOLD_BTN_REG_CONFIG: RegistrationConfig = {
  ...COMMON_REG_CONFIG,
  buttons: {
    regButton: {
      colorMode: { sandGold: true },
      isRegistrationSticky: true,
      text: 'common:button.signUpLp',
    },
    googleRegButton: {
      colorMode: { blackTransparent: true },
      borderRadius: '12px',
    },
    next: {
      colorMode: { primary: true },
    },
    back: {
      colorMode: { primary: true },
    },
    wrapBorderRadius: '10px',
  },
  withNavigationOnFirstStep: false,
  withPayments: true,
};
